module.exports = __webpack_public_path__ + "images/876e1f9c9598bac062b003e79f1a790f.png";